<div class="form-body">
  <div class="row">
    <div class="img-holder" style="width: 100%;" *ngIf="!seccionActualizar">
      <div class="bg" [ngStyle]="{'background-image': 'url(assets/images/img' + fondo + '.jpg)'}"></div>
      <div class="info-holder">
      </div>
    </div>
    <div class="form-holder" style="z-index: 999;">
      <div id="frmLogin" class="form-content">
        <div class="form-items" [ngClass]="{'hide-it': secMostrar !== 'RECUPERAR', 'show-it': secMostrar === 'RECUPERAR' }"
             style="text-align: center;
              border: 1px solid #fff;
              padding: 35px 35px 14px;
              border-radius: 20px;
              background-color: #ffffffd9;
              height: auto;
              box-shadow: 0px 0px 10px 2px #969696;">
          <div *ngIf="secMostrar === 'RECUPERAR'">
            <div>
              <img class="logo-size" src="assets/images/logo-analizamos-color-completo.svg" alt="">
            </div>
            <h3 style="color: black" *ngIf="!seccionActualizar">{{ 'AUTENTICACION.LBL_RECUPERARCONTRASENA' | translate }}</h3>
            <form name="forRecuperar" (ngSubmit)="f.valid&&recuperar();" #f="ngForm" novalidate>
              <div class="p-inputgroup">
                <input class="form-control" [type]="showPass" [(ngModel)]="newPass" autocomplete="off"
                       pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&.]).{8,}$"
                       placeholder="* {{ 'USUARIO_SESION.LBL_NUEVACONTRASENA' | translate }}" required="true"
                       id="pass_nueva" name="pass_nueva" #pass_nueva="ngModel"
                       style="margin-bottom: 10px; box-shadow: 0px 2px 3px 2px #c2c2c2;">
                <button type="button" style="height: 36px; padding: 9px"
                        (click)="show(true)"
                        class="btn btn-default"
                ><i class="fa {{eye}}"></i>
                </button>
              </div>
              <div *ngIf="f.submitted && !pass_nueva.valid">
                <p class="texto-rojo text-left"
                   [hidden]="!pass_nueva.errors.required">{{"USUARIO_SESION.LBL_CONTRASENANUEVAREQUERIDA" | translate}}</p>
                <p class="texto-rojo text-left"
                   [hidden]="!pass_nueva.errors.pattern">{{"USUARIO_SESION.LBL_CONTRASENAMINIMOCARACTER" | translate}} (#$^+=!*()&#64;%&.)</p>
              </div>

              <div class="p-inputgroup">
                <input class="form-control" [type]="showConfim" [(ngModel)]="newPassConfirm" autocomplete="off"
                       placeholder="* {{ 'USUARIO_SESION.LBL_REPETIRCONTRASENA' | translate }}" required="true"
                       id="pass_nueva2" name="pass_nueva" #pass_nueva2="ngModel"
                       style="margin-bottom: 0px; box-shadow: 0px 2px 3px 2px #c2c2c2;">
                <button type="button" style="height: 36px; padding: 9px"
                        (click)="show(false)"
                        class="btn btn-default">
                  <i class="fa {{eyeNew}}"></i>
                </button>
              </div>
              <div *ngIf="f.submitted && !pass_nueva2.valid">
                <p class="texto-rojo text-left"
                   [hidden]="!pass_nueva2.errors.required">{{"USUARIO_SESION.LBL_CONTRASENANUEVAREQUERIDA" | translate}}</p>
              </div>
              <p *ngIf="f.submitted && newPassConfirm != newPass && newPass != null && newPass != ''" class="texto-rojo text-left">
                {{"USUARIO_SESION.LBL_DEBECOINCIDIRCONTRASENA" | translate}}</p>
              <div *ngIf="!sending" style="margin-top: 5px">
                <div class="form-button text-center">
                  <button id="btnIngresar" type="submit"
                          class="ibtn btn-block">{{ 'LBL_ACTUALIZARCONTRASENA' | translate }}</button>
                  <a (click)="goBack()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                </div>
              </div>
              <div *ngIf="sending" class="text-general" style="margin-top: 5px">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{ 'LBL_PROCESANDO' | translate }}...</span>
              </div>
            </form>
          </div>
          <div id="version-app">
            <b>v {{ 'LBL_VERSIONSISTEMA' | translate}}</b>
          </div>
        </div>
        <div class="form-sent" [ngClass]="{'hide-it': secMostrar !== 'ENVIADO', 'show-it': secMostrar === 'ENVIADO' }"
             style="text-align: center;
              border: 1px solid #fff;
              padding: 35px 35px 14px;
              border-radius: 20px;
              background-color: #ffffffd9;
              height: auto;
              box-shadow: 0px 0px 10px 2px #969696;">
          <div *ngIf="secMostrar === 'ENVIADO'">
            <div>
              <img class="logo-size" src="assets/images/logo_login.png" alt=""
                   style="margin-top: -66px;margin-bottom: 34px;">
            </div>
            <div class="tick-holder">
              <div class="tick-icon"></div>
            </div>
            <h3 style="color: black;">{{ 'AUTENTICACION.MSG_PROCESOFINALIZADO' | translate }}</h3>
            <p class="text-msg" style="color: black">{{notice}}</p>
            <div style="font-size: 18px; font-weight: 700; color: black; border-top: 1px solid rgba(255, 255, 255, 0.5);
                  padding: 1px; margin-top: 60px;">
              <span><a (click)="inicio()">{{'AUTENTICACION.LBL_IRINICIO' | translate}}</a></span>
            </div>
          </div>
        </div>

        <div class="form-sent" [ngClass]="{'hide-it': secMostrar !== 'EXPIRO', 'show-it': secMostrar === 'EXPIRO' }">
          <div *ngIf="secMostrar === 'EXPIRO'">
            <h3 style="color: black">{{ 'AUTENTICACION.MSG_PROCESONOFINALIZADO' | translate }}</h3>
            <p class="text-msg" style="color: black">{{'LBL_TOKENEXPIRO' | translate}}</p>
            <div style="font-size: 18px; font-weight: 700; color: black; border-top: 1px solid rgba(255, 255, 255, 0.5);
                  padding: 1px; margin-top: 60px;">
              <span><a (click)="inicio()">{{'AUTENTICACION.LBL_IRINICIO' | translate}}</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog icon="fa fa-question-circle" header="{{ 'LBL_CONFIRMACION' | translate }}" #cd>
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
